import React from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C18AudioAssetProps } from './C18AudioAsset.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateAudioAssetModel } from './C18AudioAsset.service';
import { AudioAsset } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C18AudioAssetProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = CreateAudioAssetModel(props);

  return (
    <AudioAsset
      id={props.params?.AnchorLinkTargetName}
      className={translationClasses(props.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};
